import { motion } from "framer-motion";

interface SectionProps {
  title: string;
  description?: string;
  icon: any;
  children: React.ReactNode;
  iconColor?: string;
  iconBg?: string;
}

const ConfigSection = ({ title, description, icon: Icon, children, iconColor, iconBg }: SectionProps) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3 }}
    className="rounded-2xl border border-border bg-card shadow-sm overflow-hidden"
  >
    {/* Section header */}
    <div className="px-6 py-5 border-b border-border/50 bg-gradient-to-r from-secondary/30 to-transparent">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${iconBg || "bg-primary/10"}`}>
          <Icon className={`h-5 w-5 ${iconColor || "text-primary"}`} />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-display font-bold text-base">{title}</h2>
          {description && (
            <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
          )}
        </div>
      </div>
    </div>
    {/* Section body */}
    <div className="px-6 py-5 space-y-5">{children}</div>
  </motion.div>
);

export default ConfigSection;
export const inputClass = "h-11 bg-background border-border rounded-xl focus:ring-2 focus:ring-primary/20 transition-all";
